export const triggerFileDownload = ({
  href,
  fileName,
  linkNode,
}) => {
  if (linkNode) {
    linkNode.href = href;
    linkNode.download = fileName;
    linkNode.click();
    return;
  }

  const link = document.createElement('a');
  link.href = href;
  link.download = fileName;
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const downloadBlobFile = ({
  content = '',
  fileName,
  contentType = 'text/csv;charset=utf-8;',
  linkNode,
}) => {
  const blob = new Blob([content], { type: contentType });
  const href = window.URL.createObjectURL(blob);
  try {
    triggerFileDownload({ href, fileName, linkNode });
  } finally {
    window.setTimeout(() => {
      window.URL.revokeObjectURL(href);
      if (linkNode && linkNode.href === href) {
        linkNode.href = '';
      }
    }, 0);
  }
};

export const resolveBulkUploadResultDownload = async ({
  upload,
  uploadId,
  getBulkUploadDetails,
  onDetails,
  fileNameFallback,
  forceRefresh = false,
}) => {
  const resolvedUploadId = uploadId || upload?.id;
  if (!resolvedUploadId) {
    throw new Error('uploadId is required');
  }

  let downloadUrl = upload?.resultDownloadUrl || null;
  let fileName = upload?.resultFileName || null;

  if ((forceRefresh || !downloadUrl) && typeof getBulkUploadDetails === 'function') {
    try {
      const details = await getBulkUploadDetails({ uploadId: resolvedUploadId });
      if (details) {
        if (typeof onDetails === 'function') {
          onDetails(details);
        }
        downloadUrl = details.resultDownloadUrl || downloadUrl;
        fileName = details.resultFileName || fileName;
      }
    } catch {
      // When forceRefresh fails but a cached URL exists, fall back silently
      // so users can still download from an already-populated row.
    }
  }

  if (!downloadUrl) {
    throw new Error('Bulk upload results are not available yet.');
  }

  return {
    downloadUrl,
    fileName: fileName || fileNameFallback || `bulk-upload-${resolvedUploadId}-results.csv`,
  };
};
